import { getOrgACLEffectedDeps, getOrgACLRequiredDeps, OrgACLLabel } from '@/adapters/ACLAdapter'

interface CheckboxTableValue<T extends string> {
  label: string
  icon?: React.ReactNode
  checks: {
    [k: string]: T[]
  }
}

export function toggleChecks<V extends string, T extends CheckboxTableValue<V>>(
  idx: number,
  id: string,
  value: V,
  values: T[],
  setValues: (nextValues: T[]) => void
) {
  const copyValues = [...values]

  const isCurrentlyChecked = copyValues[idx].checks[id].includes(value)

  if (isCurrentlyChecked) {
    const deps = [...getOrgACLEffectedDeps(id as OrgACLLabel), id as OrgACLLabel]
    for (const dep of deps) {
      if (Array.isArray(dep)) {
        const newIdx = dep[0] as number
        const realDep = dep[1]
        copyValues[newIdx].checks[realDep] = copyValues[newIdx].checks[realDep].filter((x) => x !== value)
      } else {
        copyValues[idx].checks[dep] = copyValues[idx].checks[dep].filter((x) => x !== value)
      }
    }
  } else {
    const deps = [...getOrgACLRequiredDeps(id as OrgACLLabel), id as OrgACLLabel]
    for (const dep of deps) {
      if (Array.isArray(dep)) {
        const newIdx = dep[0] as number
        const realDep = dep[1]
        copyValues[newIdx].checks[realDep].push(value)
      } else {
        copyValues[idx].checks[dep].push(value)
      }
    }
  }
  setValues(copyValues)
}
